import React from "react";
import CourseCarousel from "../Cards/Card";
import Link from "next/link";

const CourseSection = () => {
  return (
    <div className="container">
      <div className="row mb--10 mt--20">
        <div className="col-lg-12">
          <div className="section-title text-center">
            <span className="subtitle bg-secondary-opacity">
              Top Popular Courses
            </span>
            <h2 className="title">
              Hot &amp; Trending: <br /> Courses You Can&apos;t Miss.
            </h2>
          </div>
        </div>
      </div>
      <div className="row mt--80">
        <CourseCarousel />
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="load-more-btn mt--30 text-center">
            <Link
              href="/course-list"
              className="rbt-btn btn-gradient btn-lg hover-icon-reverse"
            >
              <span className="icon-reverse-wrapper">
                <span className="btn-text">Load More Course</span>
                <span className="btn-icon">
                  <i className="feather-arrow-right"></i>
                </span>
                <span className="btn-icon">
                  <i className="feather-arrow-right"></i>
                </span>
              </span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseSection;
